module.exports = "/cyber/_next/static/images/1st-place-prize-0c6a263f7e813f08c983eec683084dab.png";